import { render, staticRenderFns } from "./ChannelEdit.vue?vue&type=template&id=3e82c476"
import script from "./ChannelEdit.vue?vue&type=script&lang=js"
export * from "./ChannelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports